export default __webpack_public_path__ + "static/media/power2.c1fd54dc.jpeg";